/** Initialize navigation breadcrumbs */
export function initBreadCrumbs(): void {
	const navElement = document.querySelector<HTMLDivElement>(
		".rt-breadcrumbs-inner",
	);
	const parent = document.querySelector<HTMLDivElement>(".rt-breadcrumbs");
	if (!navElement || !parent) return;
	setState(navElement, parent);
	navElement.addEventListener("scroll", function () {
		setState(navElement, parent);
	});
}

/**
 * Set the state of the breadcrumbs
 *
 * @param navElement The current nav element
 * @param parentElement The parent element of the nav
 */
function setState(navElement: HTMLDivElement, parentElement: HTMLDivElement) {
	if (navElement.scrollLeft === 0) {
		parentElement.classList.add("rt-breadcrumbs-start");
		parentElement.classList.remove("rt-breadcrumbs-end");
	} else if (
		navElement.scrollLeft + navElement.offsetWidth ===
		navElement.scrollWidth
	) {
		parentElement.classList.remove("rt-breadcrumbs-start");
		parentElement.classList.add("rt-breadcrumbs-end");
	} else {
		parentElement.classList.remove("rt-breadcrumbs-start");
		parentElement.classList.remove("rt-breadcrumbs-end");
	}
}
